import { inject, Injectable } from "@angular/core";

import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";
import { PopUpInformalType } from "../../components/ui-components/pop-ups/pop-up-informal/pop-up-informal.model";
import { PopUpInformalComponent } from "../../components/ui-components/pop-ups/pop-up-informal/pop-up-informal.component";
import { NgxSpinnerService } from "ngx-spinner";

export interface InformalDialogOptions {
  title?: string;
  message?: string;
  type?: PopUpInformalType;
  subMessage?: string;
  showPrintReceipt?: boolean;
  printReceipt?: boolean;
  showSendReceiptByEmail?: boolean;
  sendReceiptByEmail?: boolean;
  emailAddress?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  showCancelButton?: boolean;
  autoCloseMs?: number;
}

export interface ConfirmResult {
  confirmed: boolean;
  printReceipt: boolean;
  sendReceiptByEmail: boolean;
  email?: string;
}

@Injectable({ providedIn: "root" })
export class PopUpDialogInformalService {
  private _translate = inject(TranslateService);

  private readonly spinner = inject(NgxSpinnerService);

  constructor(private dialog: MatDialog) {}

  async confirm(opts: InformalDialogOptions): Promise<ConfirmResult | null> {
    console.log('[PopUpDialogInformalService] confirm called with emailAddress:', opts.emailAddress);
    this.spinner.hide();
    this.spinner.hide("paymentLoading");
    const dialogRef = this.dialog.open(PopUpInformalComponent, {
      panelClass: "full-screen-dialog",
      disableClose: true,
    });

    // set its inputs
    const inst = dialogRef.componentInstance;
    inst.title = opts.title ? this._translate.instant(opts.title) : "";
    inst.message = opts.message ? this._translate.instant(opts.message) : "";
    inst.subMessage = opts.subMessage
      ? this._translate.instant(opts.subMessage)
      : "";
    inst.type = opts.type ?? PopUpInformalType.Info;
    inst.showPrintReceipt = opts.showPrintReceipt ?? false;
    inst.printReceipt = Boolean(inst.showPrintReceipt && (opts.printReceipt ?? false)); // Must be visible to be true
    inst.showSendReceiptByEmail = opts.showSendReceiptByEmail ?? false;
    inst.sendReceiptByEmail = Boolean(inst.showSendReceiptByEmail && (opts.sendReceiptByEmail ?? true)); // Must be visible to be true
    inst.emailAddress = opts.emailAddress ?? "";
    inst.confirmButtonText = opts.confirmButtonText ? this._translate.instant(opts.confirmButtonText) : "";
    inst.cancelButtonText = opts.cancelButtonText ? this._translate.instant(opts.cancelButtonText) : "";
    inst.showCancelButton = opts.showCancelButton ?? false;
    inst.autoCloseMs = opts.autoCloseMs ?? null;
    
    // Set email address if provided (ensure it's synced)
    console.log('[PopUpDialogInformalService] About to call setEmailAddress with:', opts.emailAddress);
    inst.setEmailAddress(opts.emailAddress ?? "");

    // wait for it to close and return the payload
    return firstValueFrom(dialogRef.afterClosed()) as Promise<ConfirmResult | null>;
  }
}
